<template>
    <div class="components-container">
        <div class="filter-container">
            <el-select v-model="tableQuery.Xnxqbm" placeholder="学年学期" style="width: 220px;" v-if="tableQuery.remind!='remind'" clearable>
                <el-option v-for="(item, index) in xnxqQuery" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-select v-model="tableQuery.deptCode" placeholder="所属系部" style="width:160px" clearable filterable @change="changeOption('dept')"  v-if="tableQuery.remind!='remind'">
                <el-option v-for="item in queryCombo.dept" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-select v-model="tableQuery.majorCode" placeholder="所属专业" style="width:160px" clearable filterable @change="changeOption()" v-if="tableQuery.remind!='remind'">
                <el-option v-for="item in queryCombo.major" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-select v-model="tableQuery.gradeCode" placeholder="年级名称" style="width:160px" clearable filterable @change="changeOption()" v-if="tableQuery.remind!='remind'">
                <el-option v-for="item in queryCombo.grade" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-select v-model="tableQuery.classCode" placeholder="班级名称" style="width:160px" clearable filterable v-if="tableQuery.remind!='remind'">
                <el-option v-for="item in queryCombo.class" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-input v-model="tableQuery.Xh" @keyup.enter.native="handleFilter" style="width: 160px;" placeholder="学号 / 姓名" v-if="tableQuery.remind!='remind'" clearable></el-input>
<!--            <el-input v-model="tableQuery.Bjjc" @keyup.enter.native="handleFilter" style="width: 200px;" placeholder="班级简称" v-if="tableQuery.remind!='remind'" clearable></el-input>-->

            <el-button @click="handleFilter" type="gray" style="margin-left: 10px;" v-if="tableQuery.remind!='remind'"><i class="el-icon-search">&nbsp;查询</i></el-button>
            <el-button @click="handleReset" type="gray"  v-if="tableQuery.remind!='remind'"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button @click="warnSet" type="success" style="margin-left: 10px;" v-if="tableQuery.remind!='remind'"><i class="el-icon-document">&nbsp;学业预警设置</i></el-button>
			<el-button @click="warnExport" type="primary" style="margin-left: 10px;" v-if="tableQuery.remind!='remind'"><i class="el-icon-document">&nbsp;批量导出</i></el-button>
            <el-button @click="remind" type="warning" style="margin-left: 10px;" v-if="tableQuery.remind!='remind'"><i class="el-icon-bell">&nbsp;发送提醒</i></el-button>
        </div>

        <el-table :data="tableData" :height="mainTableHeight" ref="mainTable" v-loading.body="tableLoading"
            :header-cell-style="{'text-align':'center','background-color':'#F1FAF6'}" element-loading-text="信息加载中" stripe border fit
            highlight-current-row style="width:100%;">
            <el-table-column label="序号" width="60px" align="center">
                <template slot-scope="scope">
                    <span>{{(currentPage - 1) * limit + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column label="学年学期名称" prop="xnxqmc" align="center" min-width="20@%"></el-table-column>
            <el-table-column label="班级名称" prop="bjjc" align="center" min-width="15%"></el-table-column>
            <el-table-column label="学号" prop="xh" align="center" min-width="10%"></el-table-column>
            <el-table-column label="姓名" prop="xm" align="center" min-width="10%"></el-table-column>
            <el-table-column label="总课程数量" prop="zkcsl" align="center" min-width="10%"></el-table-column>
            <el-table-column label="合格课程数量" prop="hgkcsl" align="center" min-width="10%"></el-table-column>
            <el-table-column label="课程学分" prop="xf" align="center" min-width="10%"></el-table-column>
            <el-table-column label="获得学分" prop="hdxf" align="center" min-width="10%"></el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

        <!--批量导出dialog-->
        <el-dialog :title="exportTitle" top="25vh" :visible.sync="exportAllDialog" :before-close="handleEditDialogClose" append-to-body>
            <el-form class="small-space" :model="exportForm" :rules="rules" ref="exportForm" label-position="left" label-width="120px" style='width: 100%; margin-left:0px;'>
                <el-form-item label="学年学期" prop="exXnxq">
                    <el-select v-model="exportForm.exXnxq" placeholder="请选择" class="input-full" clearable>
                        <el-option v-for="(item, index) in xnxqInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="系部名称" prop="exXbmc">
                    <el-select v-model="exportForm.exXbmc" placeholder="全部" class="input-full" :multiple="multiple" clearable @change="initClassInfo($event,'dept')">
                        <el-option v-for="(item, index) in deptInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="专业名称" prop="exZymc">
                    <el-select v-model="exportForm.exZymc" placeholder="全部" class="input-full" :multiple="multiple" clearable @change="initClassInfo($event)">
                        <el-option v-for="(item, index) in majorInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="年级名称" prop="exNjmc">
                    <el-select v-model="exportForm.exNjmc" placeholder="全部" class="input-full" :multiple="multiple" clearable @change="initClassInfo($event)">
                        <el-option v-for="(item, index) in gradeInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级名称" prop="exBjmc">
                    <el-select v-model="exportForm.exBjmc" placeholder="全部" class="input-full" :multiple="multiple" clearable>
                        <el-option v-for="(item, index) in classInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <!-- </div> -->
            <div slot="footer" class="dialog-footer">
                <el-button v-if="type == 'export'" type="primary" :loading="formSubmiting" @click="checkResult">导 出</el-button>
                <el-button v-if="type == 'remind'" type="primary" :loading="formSubmiting" @click="submitRemind">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 学业预警设置 -->
        <el-dialog :title="'学业预警设置'" class="warnSetDialog" width="50%" top="14vh" :visible.sync="warnSetDialogVisible" @closed="closeWarnSetDialog" append-to-body>
            <div class="filter-container">
                <el-select v-model="warnSetForm.deptCode" filterable placeholder="系部名称" style="width: 210px;" @change="changeDeptSet" clearable>
                    <el-option v-for="item in deptWarnInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                    </el-option>
                </el-select>
                <el-select v-model="warnSetForm.majorCode" filterable placeholder="专业名称" style="width: 210px;" clearable>
                    <el-option v-for="item in majorWarnInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                    </el-option>
                </el-select>
                <el-button @click="queryWarnSet" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
                <el-button @click="warnSetReset" type="gray" style="margin-left: 10px"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
                <el-button @click="editWarnSet" type="warning" style="margin-left: 10px"><i class="el-icon-edit"></i>&nbsp;编辑</el-button>
                <el-button @click="editWarnSet_multi" type="warning" style="margin-left: 10px"><i class="el-icon-edit"></i>&nbsp;批量编辑</el-button>
            </div>

            <el-table :data="warnSetData" @curplus-outlinerent-change="warnSetCurrentChange" v-loading.body="tableLoading" @row-click="rowClick_warnSet"
                element-loading-text="信息加载中" highlight-current-row border style="width: 100%" :height="warnSetTableHeight" ref="warnSetTable">
                <el-table-column label="序号" width="50" align="center">
                    <template slot-scope="scope">
                        <span>{{ (currentPage_warnSet - 1) * limit_warnSet + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="系部名称" prop="deptName" align="center" min-width="20%"></el-table-column>
                <el-table-column label="专业名称" prop="majorName" align="center" min-width="20%"></el-table-column>
                <el-table-column label="专业代码" prop="majorCode" align="center" min-width="20%"></el-table-column>
                <el-table-column label="不合格科目占比(%)" prop="bhgkmzb" align="center" min-width="12%"></el-table-column>
                <el-table-column label="不合格学分占比(%)" prop="bhgxfzb" align="center" min-width="12%"></el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="warnSetSizeChange" @current-change="warnSetPageChange" :current-page.sync="currentPage_warnSet"
                    :page-sizes="[10, 20, 50]" :page-size="limit_warnSet" layout="total, sizes, prev, pager, next, jumper" :total="totalWarnSet"></el-pagination>
            </div>
        </el-dialog>

        <el-dialog :title="'学业预警占比设置'" class="editWarnSetDialog" width="40%" top="0" :visible.sync="editWarnSetDialogVisible" @closed="closeEditWarnSetDialogDialog" append-to-body>
            <el-form class="small-space" :model="editSetForm" ref="editSetForm" label-position="left" label-width="150px" style='width: 100%; margin-left:0px;'>
                <el-form-item label="系部名称" prop="deptName">
                    <div v-if="editSetForm.editSetType=='single'">{{ editSetForm.deptName }}</div>
                    <div v-if="editSetForm.editSetType=='multiple'">
                        <el-select v-model="editSetForm.deptCode" filterable placeholder="系部名称" style="width: 90%;" @change="changeDeptEdit" multiple clearable>
                            <el-option v-for="item in deptWarnSetInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="专业名称" prop="majorName">
                    <div v-if="editSetForm.editSetType=='single'">{{ editSetForm.majorName }}</div>
                    <div v-if="editSetForm.editSetType=='multiple'">
                        <el-select v-model="editSetForm.majorCode" filterable placeholder="专业名称" style="width: 90%;" multiple clearable>
                            <el-option v-for="item in majorWarnSetInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="不合格科目占比" prop="bhgkmzb">
                    <el-input-number v-model="editSetForm.bhgkmzb" :precision="0" :step="1" :min="0" :max="100" style="width:200px;"></el-input-number>&nbsp;%
                </el-form-item>
                <el-form-item label="不合格学分占比" prop="bhgxfzb">
                    <el-input-number v-model="editSetForm.bhgxfzb" :precision="0" :step="1" :min="0" :max="100" style="width:200px;"></el-input-number>&nbsp;%
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="formSubmiting" @click="saveWarnSet">保 存</el-button>
                <el-button @click="closeEditWarnSetDialogDialog">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
import { confirmMsg } from "utils/message";
import UnreadMessage from '../../utils/unreadMessage.js';

export default {
    data() {
        return {
            queryCombo:{
                grade:[],
                dept:[],
                major:[],
                class:[]
            },
            xnxqQuery: [], //学年学期下拉框
            xnxqInfo: [], //学年学期下拉框
            majorInfo: [], //专业下拉框
            gradeInfo: [], //年级下拉框
            classInfo: [], //班级下拉框
            deptInfo: [], //系部下拉框
            mainTableHeight: 500,
            tableLoading: false,
            formSubmiting: false,
            total: 0,
            exportAllDialog:false,
            multiple:true,
            tableData: [], //列表数据
            exportTitle: null,
            type: null, //导出或提醒
            limit: 10,
            currentPage: 1,
            tableQuery: { //查询数据窗口
                pageNum: 1,
                rowNum: 10,
                //frontArg:"前端参数"
                Xnxqbm: null,
                Xh: null,
                Xm: null,
                Bjdm: null,
                Bjjc: null,
                Type:'query',
                remind: '',
                gradeCode:null,
                deptCode:null,
                majorCode:null,
                classCode:null,
                hasAllAuth:false,
                authCourseDept: [],
                authDept: [],
                authMajor: [],
                authGrade: [],
                authClass: []
            },
            exportForm: { //新建编辑
                pageNum: 1,
                rowNum: 10,
                exXnxq: null,
                exZymc: null,
                exNjmc: null,
                exBjmc: null,
                exXbmc:null
            },
            rules: {//表单验证
                exXnxq: [{required: true, message: "请选择学年学期",trigger: ["blur"],}],
            },

            warnSetForm: {
                xnxqbm: null,
                gradeCode: null,
                gradeName: null,
                majorCode: null,
                majorName: null,
                courseType: null,
                courseTypeName: null,
                credit: null,
            },
            currentPage_warnSet: 1,
            limit_warnSet: 10,
            totalWarnSet: null,
            warnSetDialogVisible: false,
            warnSetSetDialogVisible: false,
            warnSetData: [],
            selWarnSetRow: null,
            warnSetTableHeight: 500,

            deptWarnInfo: [],
            majorWarnInfo: [],
            deptWarnSetInfo: [],
            majorWarnSetInfo: [],
            editSetForm: {
                deptCode: null,
                deptName: null,
                majorCode: null,
                majorName: null,
                bhgkmzb: null,
                bhgxfzb: null,
                editSetType: null,
            },
            editWarnSetDialogVisible: false,
            tempMajor:[]
        };
    },
    created() {
        if(this.$route.query.remind == "remind"){
            this.tableQuery.remind = this.$route.query.remind;
            this.tableQuery.Bjdm = this.$route.query.classCode;
        }
        this.queryUserInfo()
    },
    mounted() {
        this.$nextTick(function() {
            //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
            //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
            this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
            // 监听窗口大小变化
            let self = this;
            window.onresize = function() {
                self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145
            }
        });
    },
    methods: {
        queryUserInfo() {
            this.$api.system.dataAuth.queryUserDataAuth({}).then((res) => {
                let info = res.data.data;
                if (info) {
                    if (!info.hasAllAuth) {
                        if (info.hasCourseDeptAuth) this.tableQuery.authCourseDept = info.courseDeptCodes
                        if (info.hasDeptAuth) this.tableQuery.authDept = info.deptCodes
                        if (info.hasMajorAuth) this.tableQuery.authMajor = info.majorCodes
                        if (info.hasGradeAuth) this.tableQuery.authGrade = info.gradeCodes
                        if (info.hasClassAuth) this.tableQuery.authClass = info.classCodes
                    }else {
                        this.tableQuery.hasAllAuth = info.hasAllAuth
                    }
                    this.initParam();
                } else {
                    this.$router.push('/login');
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        changeOption(type){
            this.tableQuery.classCode = null
            let param = {}
            param = {
                "gradeCode":this.tableQuery.gradeCode,
                "deptCode":this.tableQuery.deptCode,
                "majorCode":this.tableQuery.majorCode
            }

            if(type === 'dept'){
                this.tableQuery.majorCode = null
                this.$api.common.comboOption.major({
                    data:param
                }).then((res) => {
                    this.queryCombo.major = res.data.data.comboData
                }).catch((err) => {
                    console.log(err);
                });
            }

            this.$api.common.comboOption.class({
                data:param
            }).then((res) => {
                this.queryCombo.class = res.data.data.comboData
            }).catch((err) => {
                console.log(err);
            });
        },
        initParam() {
            const paramMap = {
                'name': 'schoole_Info'
            }
            this.$api.academicWarning.academicWarning.initOption({
                data: paramMap
            }).then(response => {
                this.xnxqQuery = response.data.data.xnxqQuery;
                this.xnxqInfo = response.data.data.xnxq;
                this.tableQuery.Xnxqbm = this.xnxqQuery[0].comboValue;
                this.majorInfo = response.data.data.major;
                this.gradeInfo = response.data.data.grade;
                this.deptInfo = response.data.data.dept;
                this.tempMajor = response.data.data.major
                this.queryXYYJList();
                this.initQueryCombo();
                this.initClassInfo();
                this.deptWarnOption();
            }).catch(error => {
                console.log(error);
            });
        },
        initQueryCombo(){
            this.$api.academicWarning.academicWarning.initQueryCombo({})
                .then((res) => {
                    this.queryCombo.grade = res.data.data.grade;
                    this.queryCombo.dept = res.data.data.dept;
                    this.queryCombo.major = res.data.data.major;
                    this.queryCombo.class = res.data.data.class;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        initClassInfo(event,type) {
            if(type === 'dept'){
                this.exportForm.exZymc = null

                const param = {
                    'deptCode': this.exportForm.exXbmc.length > 0 ? this.exportForm.exXbmc.join((",")) : "",
                }

                this.$api.academicWarning.academicWarning.loadMajorInfo({
                    data: param,
                })
                    .then((res) => {
                        this.majorInfo = res.data.data.comboData
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
            this.exportForm.exBjmc = null;
            let zydm = "";
            let njdm = "";
            let xbdm = "";
            if(this.exportForm.exZymc==null){
                zydm = this.exportForm.exZymc;
            }else{
                zydm = this.exportForm.exZymc+"";
            }
            if(this.exportForm.exNjmc==null){
                njdm = this.exportForm.exNjmc;
            }else{
                njdm = this.exportForm.exNjmc+"";
            }
            if(this.exportForm.exXbmc==null){
                xbdm = this.exportForm.exXbmc;
            }else{
                xbdm = this.exportForm.exXbmc+"";
            }

            const paramMap = {
                'Zymc': zydm,
                'Njmc': njdm,
                'Xbmc': xbdm
            }
            this.$api.academicWarning.academicWarning.classInfoOption({
                data: paramMap
            }).then(response => {
                this.classInfo = response.data.data.class;
                //alert(JSON.stringify(response.data.data));
            }).catch(error => {
                console.log(error);
            });
        },
        queryXYYJList(){
            this.tableLoading=true;
            this.tableQuery.pageNum = this.currentPage;
            this.tableQuery.rowNum = this.limit;
            //后端请求api
            this.$api.academicWarning.academicWarning.list({
                //传到后端的数据
                data:this.tableQuery
            }).then(response => {
                //成功时的返回值
                this.tableLoading=false;
                //查看返回值，进行相应处理
                this.tableData=response.data.data.list;
                this.total=response.data.data.total;
            }).catch(error => {
                //出错时的返回值
                this.tableLoading=false;
                console.log(error);
            });
        },
        handleFilter() {
            this.tableQuery.currentPage = 1;
            this.queryXYYJList();
        },
        handleSizeChange(val) {
            this.tableQuery.limit = val;
            this.queryXYYJList();
        },
        handleCurrentChange(val) {
            this.tableQuery.currentPage = val;
            this.queryXYYJList();
        },
        handleEditDialogClose() {
            this.exportAllDialog = false;
            this.$refs["exportForm"].resetFields();
            this.exportForm.exXnxq = null;
            this.exportForm.exZymc = null;
            this.exportForm.exNjmc = null;
            this.exportForm.exBjmc = null;
            this.majorInfo = this.tempMajor
        },
        warnExport(){
            this.exportTitle = "批量导出";
            this.type = "export";
            this.exportAllDialog = true;
            this.initClassInfo();
        },
        checkResult(){
            this.$refs['exportForm'].validate((valid) => {
                if (valid) {
                    this.showLoadingMask("学业预警信息导出中，请稍候...");

                    let zydm = "";
                    let njdm = "";
                    let bjdm = "";
                    if(this.exportForm.exZymc==null){
                        zydm = this.exportForm.exZymc;
                    }else{
                        zydm = this.exportForm.exZymc+"";
                    }
                    if(this.exportForm.exNjmc==null){
                        njdm = this.exportForm.exNjmc;
                    }else{
                        njdm = this.exportForm.exNjmc+"";
                    }
                    if(this.exportForm.exBjmc==null){
                        bjdm = this.exportForm.exBjmc;
                    }else{
                        bjdm = this.exportForm.exBjmc+"";
                    }

                    const paramMap = {
                        'Xnxqbm': this.exportForm.exXnxq,
                        'Zymc': zydm,
                        'Njmc': njdm,
                        'Bjmc': bjdm,
                        'Type':'export',
                        'authCourseDept':this.tableQuery.authCourseDept,
                        'authDept':this.tableQuery.authDept,
                        'authMajor':this.tableQuery.authMajor,
                        'authGrade':this.tableQuery.authGrade,
                        'authClass':this.tableQuery.authClass,
                    }
                    //后端请求api
                    this.$api.academicWarning.academicWarning.checkResult({
                        //传到后端的数据
                        data:paramMap
                    }).then(response => {
                        //查看返回值，进行相应处理
                        let reslut = response.data.data.result;
                        if(reslut == "true"){
                            this.multipleExport();
                        }else{
                            this.$notify({
                                title: '失败',
                                message: '查询不到符合条件的数据',
                                type: 'error',
                                duration: 1500,
                            });

                            this.closeLoadingMask();
                        }
                    }).catch(error => {
                        console.log(error);
                        this.closeLoadingMask();
                    });
                }
            });
        },
        multipleExport() {
            let zydm = "";
            let njdm = "";
            let bjdm = "";
            if(this.exportForm.exZymc==null){
                zydm = this.exportForm.exZymc;
            }else{
                zydm = this.exportForm.exZymc+"";
            }
            if(this.exportForm.exNjmc==null){
                njdm = this.exportForm.exNjmc;
            }else{
                njdm = this.exportForm.exNjmc+"";
            }
            if(this.exportForm.exBjmc==null){
                bjdm = this.exportForm.exBjmc;
            }else{
                bjdm = this.exportForm.exBjmc+"";
            }
            const paramMap = {
                'Xnxqbm': this.exportForm.exXnxq,
                'Zymc': zydm,
                'Njmc': njdm,
                'Bjmc': bjdm,
                'Type':'export',
                'Result':'',
            }
            this.$api.academicWarning.academicWarning.multipleExport({
                data: paramMap,
                responseType: "blob",
            }).then((response) => {
                const content = response.data;
                const blob = new Blob([content]);

                let year = new Date().getFullYear();//年
                let month = new Date().getMonth() +1;//注意！月份是从0月开始获取的，所以要+1;
                let day = new Date().getDate();//日
                //拼接日期
                let yearMD = year + (month >=10 ? month:'0'+ month) + (day >=10 ? day:'0' + day);

                const fileName = "学生学业预警通知书" + yearMD + ".zip";
                if ("download" in document.createElement("a")) {
                    // 非IE下载
                    const elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, fileName);
                }
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.closeLoadingMask();
            });
        },
        remind(){
            this.exportTitle = "提醒";
            this.type = "remind";
            this.exportAllDialog = true;
        },
        submitRemind(){
            this.$refs['exportForm'].validate((valid) => {
                if (valid) {
                    let zydm = "";
                    let njdm = "";
                    let bjdm = "";
                    if(this.exportForm.exZymc==null){
                        zydm = this.exportForm.exZymc;
                    }else{
                        zydm = this.exportForm.exZymc+"";
                    }
                    if(this.exportForm.exNjmc==null){
                        njdm = this.exportForm.exNjmc;
                    }else{
                        njdm = this.exportForm.exNjmc+"";
                    }
                    if(this.exportForm.exBjmc==null){
                        bjdm = this.exportForm.exBjmc;
                    }else{
                        bjdm = this.exportForm.exBjmc+"";
                    }
                    const paramMap = {
                        'Xnxqbm': this.exportForm.exXnxq,
                        'Zymc': zydm,
                        'Njmc': njdm,
                        'Bjmc': bjdm,
                        'Type':'remind',
                    }
                    this.tableLoading=true;
                    //后端请求api
                    this.$api.academicWarning.academicWarning.remind({
                        //传到后端的数据
                        data: paramMap,
                    }).then(response => {
                        //成功时的返回值
                        this.tableLoading=false;
                        let reslut = response.data.data.result;
                        if(reslut == "true"){
                            this.$notify({
                                title: '成功',
                                message: '已发送提醒',
                                type: 'success',
                                duration: 1500,
                            });
                            this.callUnread();
                            //this.handleEditDialogClose();
                        }else{
                            this.$notify({
                                title: '失败',
                                message: '查询不到符合条件的数据',
                                type: 'error',
                                duration: 1500,
                            });
                        }
                    }).catch(error => {
                        //出错时的返回值
                        this.tableLoading=false;
                        console.log(error);
                    });
                }
            });
        },
        callUnread(){
            UnreadMessage.$emit('demo','msg');
        },
        //学业预警设置
        deptWarnOption(){
            const paramMap = {
                'name': 'combo_Info'
            }
            this.$api.academicWarning.academicWarning.deptWarnOption({
                data: paramMap
            }).then(response => {
                this.deptWarnInfo = response.data.data.dept;
                this.deptWarnSetInfo = response.data.data.dept;
                this.majorWarnOption();
                this.majorWarnSetOption();
            }).catch(error => {
                console.log(error);
            });
        },
        majorWarnOption(){
            const paramMap = {
                'deptCode': this.warnSetForm.deptCode,
            }
            this.$api.academicWarning.academicWarning.majorWarnOption({
                data: paramMap
            }).then(response => {
                this.majorWarnInfo = response.data.data.major;
            }).catch(error => {
                console.log(error);
            });
        },
        majorWarnSetOption(){
            const paramMap = {
                'deptCode': this.editSetForm.deptCode+"",
            }
            this.$api.academicWarning.academicWarning.majorWarnSetOption({
                data: paramMap
            }).then(response => {
                this.majorWarnSetInfo = response.data.data.major;
            }).catch(error => {
                console.log(error);
            });
        },
        changeDeptSet(val){
            this.majorWarnOption();
        },
        changeDeptEdit(val){
            this.majorWarnSetOption();
        },
        warnSet(){
            this.queryWarnSet();
            this.warnSetDialogVisible = true;
        },
        queryWarnSet(){
            this.tableLoading = true;
            this.warnSetForm.pageNum = this.currentPage_warnSet;
            this.warnSetForm.rowNum = this.limit_warnSet;

            this.$api.academicWarning.academicWarning.queryWarnSet({
                data: this.warnSetForm,
            }).then((response) => {
                this.warnSetData = response.data.data.list;
                this.totalWarnSet = response.data.data.total;
                this.tableLoading = false;
            }).catch((error) => {
                this.tableLoading = false;
                console.log(error);
            });
        },
        warnSetReset(){
            this.warnSetForm.deptCode = '';
            this.warnSetForm.majorCode = '';
            this.tableLoading = false;
            this.queryWarnSet();
        },
        rowClick_warnSet(row){
            this.selWarnSetRow = row;
        },
        editWarnSet(){
            if (this.selWarnSetRow == null) {
                this.$message({
                    title: '提示',
                    message: '请选择一条数据！',
                    type: 'warning',
                    duration: 2000,
                });
                return;
            }
            this.editSetForm.editSetType = "single";
            this.editSetForm.deptCode = this.selWarnSetRow.deptCode;
            this.editSetForm.deptName = this.selWarnSetRow.deptName;
            this.editSetForm.majorCode = this.selWarnSetRow.majorCode;
            this.editSetForm.majorName = this.selWarnSetRow.majorName;
            if(this.selWarnSetRow.bhgkmzb==""){
                this.editSetForm.bhgkmzb = undefined;
            }else{
                this.editSetForm.bhgkmzb = this.selWarnSetRow.bhgkmzb;
            }
            if(this.selWarnSetRow.bhgxfzb==""){
                this.editSetForm.bhgxfzb = undefined;
            }else{
                this.editSetForm.bhgxfzb = this.selWarnSetRow.bhgxfzb;
            }
            $('.editWarnSetDialog .el-dialog').css('top', (window.innerHeight-426)/window.innerHeight*100/2+'vh');
            this.editWarnSetDialogVisible = true;
        },
        editWarnSet_multi(){
            this.editSetForm.editSetType = "multiple";
            this.editSetForm.bhgkmzb = undefined;
            this.editSetForm.bhgxfzb = undefined;

            $('.editWarnSetDialog .el-dialog').css('top', (window.innerHeight-426)/window.innerHeight*100/2+'vh');
            this.editWarnSetDialogVisible = true;
        },
        saveWarnSet(){
            if(this.editSetForm.editSetType == "multiple"){
                this.editSetForm.deptCode = this.editSetForm.deptCode+"";
                this.editSetForm.majorCode = this.editSetForm.majorCode+"";
            }
            var bhgkmzb = "";
            var bhgxfzb = "";
            if(this.editSetForm.bhgkmzb==undefined){
                bhgkmzb = "";
            }else{
                bhgkmzb = this.editSetForm.bhgkmzb;
            }
            if(this.editSetForm.bhgxfzb==undefined){
                bhgxfzb = "";
            }else{
                bhgxfzb = this.editSetForm.bhgxfzb;
            }

            const paramMap = {
                'deptCode': this.editSetForm.deptCode,
                'majorCode': this.editSetForm.majorCode,
                'bhgkmzb': bhgkmzb,
                'bhgxfzb': bhgxfzb,
                'editSetType': this.editSetForm.editSetType,
            }
            this.$api.academicWarning.academicWarning.saveWarnSet({
                data: paramMap,
            }).then((response) => {
                let state = response.data.data.state;
                let msg = response.data.data.msg;

                if (state == 'Success') {
                    this.$notify({
                        title: "成功",
                        message: msg ? msg : "保存成功",
                        type: "success",
                        duration: 1500,
                    });

                    this.queryWarnSet();
                    this.editWarnSetDialogVisible = false;
                }else{
                    this.$notify({
                        title: "失败",
                        message: msg ? msg : '保存失败',
                        type: "error",
                        duration: 3000,
                    });
                }
            }).catch((error) => {
                this.$notify({
                    title: "错误",
                    message: error,
                    type: "error",
                    duration: 3000,
                });
            });
        },
        warnSetCurrentChange(val) {
           this.selectRowData = val;
        },
        currentChangeWarnSet(val){

        },
        warnSetSizeChange(val){
            this.limit_warnSet = val;
            this.currentPage_warnSet = 1;
            this.queryWarnSet();
        },
        warnSetPageChange(val){
            this.currentPage_warnSet = val;
            this.queryWarnSet();
        },
        closeWarnSetDialog(){
            this.selWarnSetRow = null;
            this.warnSetDialogVisible = false;
        },
        closeWarnSetDialog(){
            this.warnSetForm.xnxqbm = null;
            this.warnSetForm.gradeCode = null;
            this.warnSetForm.gradeName = null;
            this.warnSetForm.majorCode = null;
            this.warnSetForm.majorName = null;
            this.warnSetForm.courseType = null;
            this.warnSetForm.courseTypeName = null;
            this.warnSetForm.credit = null;
            this.warnSetFormSetDialogVisible = false;
        },
        closeEditWarnSetDialogDialog(){
            this.editSetForm.deptCode = null;
            this.editSetForm.deptName = null;
            this.editSetForm.majorCode = null;
            this.editSetForm.majorName = null;
            this.editSetForm.bhgkmzb = null;
            this.editSetForm.bhgxfzb = null;

            this.editWarnSetDialogVisible = false;
        },
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        closeLoadingMask() {
            if(this.loadingMask) this.loadingMask.close();
        },
        handleReset() {
            this.tableQuery.pageNum = 1;
            this.tableQuery.rowNum = 10;
            this.tableQuery.Xnxqbm = null;
            this.tableQuery.gradeCode = null;
            this.tableQuery.deptCode = null;
            this.tableQuery.majorCode = null;
            this.tableQuery.classCode = null;
            this.tableQuery.Xh = null;
            this.changeOption('dept')
            this.handleFilter()
        },
    },
};
</script>

<style >
    .el-table .hidden-table-row {
        display: none;
    }
    .title_export{
        height:50px;
    }
    .ex_label1{
        padding-top:5px;
    }
    .ex_label2{
        text-align:right;
        padding-right:10px;
        padding-top:5px;
    }
    .warnSetDialog /deep/ .el-table__body-wrapper {
        height: calc(100% - 70px) !important;
    }
</style>



// WEBPACK FOOTER //
// academicWarning.vue?5f560a40